import '.n{width:100%;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.ai{flex:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.cz{align-content:center;}.ssr-plugin'
import '.at{justify-content:space-between;}.ssr-plugin'
import gemeenteUtrechtImage from '@app/assets/images/partners/gemeente-utrecht.svg'
import gemeenteAlmereImage from '@app/assets/images/partners/gemeente-almere.svg'
import gemeenteRotterdamImage from '@app/assets/images/partners/gemeente-rotterdam.svg'
import provincieDrentheImage from '@app/assets/images/partners/provincie_drenthe.svg'
import provincieZuidHollandImage from '@app/assets/images/partners/provincie_zuid_holland.svg'
import RabobankImage from '@app/assets/images/partners/rabobank.svg'
import FaseImage from '@app/assets/images/partners/fase.png'

import { Image } from '@app/components/core/image/Image'
import useMediaQuery from '@app/util/useMediaQuery'
import { styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { ScrollingBanner } from '@app/components/core/scrollingBanner/ScrollingBanner'
import { useTranslations } from '@i18n/useLanguage'

const partners = [
  {
    imageAlt: 'Provincie Drenthe',
    imageSrc: provincieDrentheImage,
    maxWidth: '9rem',
  },
  {
    imageAlt: 'Provincie Zuid-Holland',
    imageSrc: provincieZuidHollandImage,
    maxWidth: '11rem',
  },
  {
    imageAlt: 'Gemeente Rotterdam',
    imageSrc: gemeenteRotterdamImage,
    maxWidth: '12rem',
  },
  {
    imageAlt: 'Rabobank',
    imageSrc: RabobankImage,
    maxWidth: '8rem',
  },
  {
    imageAlt: 'Gemeente Utrecht',
    imageSrc: gemeenteUtrechtImage,
    maxWidth: '6rem',
  },
  {
    imageAlt: 'Gemeente Almere',
    imageSrc: gemeenteAlmereImage,
    maxWidth: '8rem',
  },
  {
    imageAlt: 'Fase',
    imageSrc: FaseImage,
    maxWidth: '6rem',
  },
]

export const OurPartners = () => {
  const isMobile = useMediaQuery()
  const t = useTranslations()

  return (
    <div className="n a"
      style={{
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? '1rem' : '2rem',
      }}
    >
      <Title.H5
        style={{
          marginBottom: 0,
          width: '4.5rem',
          alignSelf: isMobile ? 'flex-start' : 'center',
        }}
      >
        {t.app.forMunicipalities.partners.title}
      </Title.H5>
      {isMobile ? (
        <ScrollingBanner>
          <PartnersImageRow />
        </ScrollingBanner>
      ) : (
        <PartnersImageRow />
      )}
    </div>
  )
}

const PartnersImageRow = () => {
  const isMobile = useMediaQuery()

  return (
    <div className="ai a r cz at"
    >
      {partners.map((partner) => (
        <Image
          key={partner.imageAlt}
          src={partner.imageSrc}
          alt={partner.imageAlt}
          resizeHeight={isMobile ? 40 : 44}
          style={{
            width: 'auto',
            maxWidth: partner.maxWidth,
            objectFit: 'contain',
          }}
        />
      ))}
    </div>
  )
}
